
export default {
  props: { siteReview: { type: Array, default: () => [] } },
};
